import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { styled } from '../styles';
const Component = styled('div', {
  shouldForwardProp: prop => prop !== 'inheritsColor'
})<{
  inheritsColor?: boolean;
}>(({
  theme: {
    palette
  },
  inheritsColor
}) => ({
  '& a': {
    color: inheritsColor ? 'inherit' : palette.primary.main,
    '&:hover': {
      textDecoration: 'none',
      ...(inheritsColor ? {
        color: 'inherit'
      } : {})
    }
  },
  '& a[target="_blank"]': {
    paddingRight: 22,
    // width of the background image
    backgroundImage: `url("data:image/svg+xml,%3Csvg width='14' height='14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.25 12.25H1.75V1.75H7V.25H1.75a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h10.5c.825 0 1.5-.675 1.5-1.5V7h-1.5v5.25ZM8.5.25v1.5h2.693L3.82 9.123l1.058 1.057 7.372-7.372V5.5h1.5V.25H8.5Z' fill='%23757575'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center right 2px'
  }
}));
export interface Props {
  children: ReactNode;
  component?: 'div' | 'span';
  shouldInheritColor?: boolean;
}
const EnrichText = t0 => {
  const $ = _c(4);
  const {
    children,
    component: t1,
    shouldInheritColor: t2
  } = t0;
  const component = t1 === undefined ? "div" : t1;
  const shouldInheritColor = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== children || $[1] !== component || $[2] !== shouldInheritColor) {
    t3 = <Component as={component} inheritsColor={shouldInheritColor}>{children}</Component>;
    $[0] = children;
    $[1] = component;
    $[2] = shouldInheritColor;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default EnrichText;